import { URLQueryParamNames } from '@src/types/urlQueryParamNames';

import type { QueryMapSetup } from '../types/minhelseentities';
import type { VerktoyFilterState } from '../types/stateTypes';
import type { VerktoyFiltersSettings } from '@components/verktoy-liste/verktoy-filter/types/verktoy-filter-settings';

export type Filters = {
  [key: string]: string | undefined | boolean;
};

/** Hjelpemetode som forhindrer unødvendige kall til APIet når filteret ikke har noen reelle endringer */
export const erMinstEttFilterParameterSatt = (verktoyFilter: VerktoyFilterState): boolean => {
  return (
    verktoyFilter.Fagomrader.length > 0 ||
    verktoyFilter.Malgrupper.length > 0 ||
    verktoyFilter.VerktoyTyper.length > 0 ||
    verktoyFilter.IsAnonymCheckboxChecked === true ||
    (verktoyFilter.SokeString !== '' && verktoyFilter.SokeString !== undefined) ||
    (verktoyFilter.Sortering !== '' && verktoyFilter.Sortering !== undefined) ||
    (verktoyFilter.SorterStigende !== '' && verktoyFilter.SorterStigende !== undefined)
  );
};

/** Hjelpemetode som forhindrer unødvendige kall til APIet når filteret ikke har noen reelle endringer */
export const erMinstEttFilterParameterSattUtenomSortering = (verktoyFilter: VerktoyFilterState): boolean => {
  return (
    verktoyFilter.Fagomrader.length > 0 ||
    verktoyFilter.Malgrupper.length > 0 ||
    verktoyFilter.VerktoyTyper.length > 0 ||
    verktoyFilter.IsAnonymCheckboxChecked === true ||
    (verktoyFilter.SokeString !== '' && verktoyFilter.SokeString !== undefined)
  );
};

const setDefaultFilters = (filters: Filters, keyprefix: string, filterValueFromUrl: QueryMapSetup[], filterValgt: string[]): void => {
  const filteredFagomraader = filterValueFromUrl.filter(fagqp => filterValgt.includes(fagqp.value));
  filteredFagomraader.forEach(e => {
    filters[`${keyprefix}-${e.displayname}`] = e.displayname;
  });
};

export const getDefaultVerktoyFilters = (verktoyFilters: VerktoyFiltersSettings): Filters => {
  const defaultValues: Filters = {};
  setDefaultFilters(
    defaultValues,
    URLQueryParamNames.Fagomrade.toLowerCase(),
    verktoyFilters.fagomraadeValueFromUrl,
    verktoyFilters.fagomraadeValgt
  );
  setDefaultFilters(
    defaultValues,
    URLQueryParamNames.Malgruppe.toLowerCase(),
    verktoyFilters.malgrupperValueFromUrl,
    verktoyFilters.malgrupperValgt
  );
  setDefaultFilters(
    defaultValues,
    URLQueryParamNames.VerktoyType.toLowerCase(),
    verktoyFilters.verktoytyperValueFromUrl,
    verktoyFilters.verktoytyperValgt
  );
  if (verktoyFilters.stotterAnonymOppstartChecked) {
    defaultValues[URLQueryParamNames.StotterAnonymOppstart] = verktoyFilters.stotterAnonymOppstartCheckedValue; // STOTTER_ANONYM_OPPSTART_QUERY_PARAM
  }
  return defaultValues;
};
